document.addEventListener('DOMContentLoaded', function() {
  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) {
    return;
  }

  function getProductTitle() {
    // Try common selectors for product title (adjust if your theme uses a different one)
    return (
      document.querySelector('h1.product__title')?.textContent.trim() ||
      document.querySelector('.product-title')?.textContent.trim() ||
      document.querySelector('h1')?.textContent.trim() ||
      ''
    );
  }

  function prefillForm() {
    const input = document.querySelector('#storeifyInput_web'); // Or '.out-storeifyInput_web input' if ID changes
    if (input) {
      const title = getProductTitle();
      if (title) {
        input.value = title;
        input.setAttribute('data-default', title); // Helps with form resets
        input.dispatchEvent(new Event('input', { bubbles: true })); // Trigger validation/listeners
        input.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('✅ Prefilled Product Name with:', title);
        clearInterval(interval); // Stop polling once successful
      } else {
        console.log('❌ No product title found in DOM. Check your title selector.');
      }
    } else {
      console.log('🔍 Form input (#storeifyInput_web) not found yet...');
    }
  }

  // Initial check
  prefillForm();

  // Poll every 500ms for up to 10 seconds (covers most async loads)
  const interval = setInterval(prefillForm, 500);
  setTimeout(() => {
    clearInterval(interval);
    console.log('⏰ Polling stopped after 10s. If form still empty, check logs above.');
  }, 10000);
});